import type { RateCell as RateCellKind } from '../../../../utils/lineVatRows';
import { vatRateLabel } from '../../../../utils/vatRateLabel';
import { UnsplitBadge } from './UnsplitBadge';

const ratesText = (count: number): string => `(${count} ${count === 1 ? 'rate' : 'rates'})`;

function RateContent({ cell }: { cell: RateCellKind }) {
    if (cell.kind === 'rate') return <>{vatRateLabel(cell.percent)}</>;
    if (cell.kind === 'rates') return <span className="text-mp-muted">{ratesText(cell.count)}</span>;
    if (cell.kind === 'unsplit') return <UnsplitBadge />;
    return null;
}

export function RateCell({ cell }: { cell: RateCellKind }) {
    return (
        <dd className="text-right">
            <span className="sr-only">VAT rate, </span>
            <RateContent cell={cell} />
        </dd>
    );
}
